import React from 'react';

import NarrativeChapter from './NarrativeChapter';

/**
 * Renders the one-active-match focus chapter. Accepts no props.
 *
 * @returns {React.ReactElement} Chapter two with peripheral decorative signals
 *   yielding to one mutual signal.
 * @sideEffects Has no external side effects beyond React rendering.
 */
export default function FocusChapter({ index = 4 }) {
  return (
    <NarrativeChapter
      index={index}
      id="focus"
      tone="dark"
      title="When it’s mutual, everything else goes quiet."
      body="One active match at a time. Discovery pauses so the match has room to become real."
    >
      <div className="focus-signals" aria-hidden="true">
        <span className="focus-signals__peripheral focus-slot">
          <span className="focus-slot__badge">Nearby</span>
          <span className="focus-slot__profile">
            <span className="focus-slot__avatar">E</span>
            <span className="focus-slot__traits">Gardening • Cooking</span>
          </span>
        </span>
        <span className="focus-signals__mutual focus-slot">
          <span className="focus-slot__badge">Mutual match</span>
          <span className="focus-slot__profile">
            <span className="focus-slot__avatar">M</span>
            <span className="focus-slot__traits">Art • Tea • Philosophy</span>
          </span>
        </span>
        <span className="focus-signals__peripheral focus-slot">
          <span className="focus-slot__badge">Maybe</span>
          <span className="focus-slot__profile">
            <span className="focus-slot__avatar">K</span>
            <span className="focus-slot__traits">Running • Design</span>
          </span>
        </span>
      </div>
    </NarrativeChapter>
  );
}
